import React, { useRef, useState } from "react";
import { CardCvcElement, CardExpiryElement, CardNumberElement } from "@stripe/react-stripe-js";
import "../Components/FormTextInput.css";

function FormCardInput({
  placeholder,
  color,
  correct,
  incorrect,
  width = "100%",
  maxWidth = "100%",
  type = "number",
  onReady,
  onChange = (e) => { },
  empty,
  setEmpty
}) {

  const [cardType, setCardType] = useState("");
  const options = {
    style: {
      base: {
        color: "#030F23",
        fontSize: "13px",
        fontFamily: '"Inter", sans-serif',
        fontWeight: "400",
        "::placeholder": {
          color: "#fff",
        }
      },
    }
  }


  return (
    <div className={"formInputSimpleContainer"} style={{
      width: width, maxWidth: maxWidth, borderColor: incorrect
        ? "#D70015"
        : correct
          ? "#eff0f2"
          : color || "#eff0f2",
    }}>

      <div className="w-full cursor-text">
        {type === "number" &&
          <CardNumberElement className="cardInput" options={options} onReady={onReady} onFocus={() => setEmpty("a")} onBlur={() => setEmpty(cardType)} onChange={(e) => { setCardType(e.empty ? "" : e.brand); onChange(e) }} />
        }
        {type === "expiry" &&
          <CardExpiryElement className="cardInput" options={options} onReady={onReady} onFocus={() => setEmpty("a")} onBlur={() => setEmpty(cardType)} onChange={(e) => { setCardType(e.empty ? "" : e.brand); onChange(e) }} />
        }
        {type === "cvc" &&
          <CardCvcElement className="cardInput" options={options} onReady={onReady} onFocus={() => setEmpty("a")} onBlur={() => setEmpty(cardType)} onChange={(e) => { setCardType(e.empty ? "" : e.brand); onChange(e) }} />
        }

      </div>

      <p
        className={`formInputSimpleLabel ${empty !== "" && "validInputLabel"}`}
      >
        {placeholder}
      </p>


    </div>
  );
}

export { FormCardInput };
